export const TAINT_PROFILES = [
  {
    type: 'Chlorophenol',
    profile: 'TCP / DCP - Anticeptic, chemical, bitter.',
    comment:
      'Forms when chlorine interacts with Phenol compounds naturally found in beers. In particular dark beers like Guinness. Some sources of chlorine can be from improper line cleaning, overchlorination of rinse waters, or bleaching cellar surfaces.'
  },
  {
    type: 'Trichloroanisole',
    profile: 'Water Taint - mouldy, musty, damp. Known as Cork Taint in winemaking.',
    comment:
      'Forms when chlorophenols are converted to TCA compounds, usually by moulds or fungi, or through extended exposure to chlorinated water such as when beer lines are "left in water". Humans are particularly sensitive to this compound so can detect extremely small amounts present in beer.'
  },
  {
    type: 'Infection / Off Beer',
    profile: 'Vinegar, rotting vegetables.',
    comment:
      'Caused when spoilage occurs in the product, due to infection or spoilage over extended periods of time. Common in slow selling products. This can leach into the lines if lefft untreated.'
  },
  {
    type: 'Oxidation',
    profile: 'Trans-2-nonenal - carboard, sherry, dull.',
    comment: 'An off flavour in stale beer. Results from the oxidation of unsaturated fatty acids in the beer.'
  }
];
